import { useNavigate } from 'react-router-dom';

import useIsMobile from '@/hooks/useIsMobile.ts';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';

import * as S from './style.ts';

interface PublicationAdvertisementGuideProps {}

const PublicationAdvertisementGuide: React.FC<PublicationAdvertisementGuideProps> = (props) => {
	const isMobile = useIsMobile(900);

	const navigate = useNavigate();
	const { isLogin } = useTokenStore();
	const { showModal } = useModalStore();

	const onClickSignUp = () => {
		if (isLogin()) {
			showModal('이미 화장품학회 회원이십니다.', 'confirm');
			return;
		} else {
			navigate('/auth/signup');
			return;
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>대한화장품학회지 광고게재 안내</S.ContentTitle>
				<S.ContentListLayout>
					<S.ContentTitleSub>발행회수</S.ContentTitleSub>
					<S.ContentDescription>연 4 회</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>발행일</S.ContentTitleSub>
					<S.ContentDescription>3월, 6월, 9월, 12월 각 발행 월 30일</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>1회 광고료</S.ContentTitleSub>
					<S.Table className="table1">
						<S.TableHeadCell className="item1 center" style={{ gridArea: 'item1' }}>
							구분
						</S.TableHeadCell>
						{/* <S.TableHeadCell style={{ gridArea: 'item2' }}>뒷표지</S.TableHeadCell> */}
						<S.TableHeadCell className="center" style={{ gridArea: 'item3' }}>
							뒷 표지 안쪽
						</S.TableHeadCell>
						{/* <S.TableHeadCell style={{ gridArea: 'item4' }}>앞쪽 내지 1쪽</S.TableHeadCell> */}
						<S.TableHeadCell className="center" style={{ gridArea: 'item5' }}>
							앞쪽 내지 2쪽 이하
						</S.TableHeadCell>
						<S.TableHeadCell className="center" style={{ gridArea: 'item6' }}>
							뒤쪽 내지부분
						</S.TableHeadCell>

						{!isMobile && (
							<S.TableCell style={{ gridArea: 'item7' }} className="min-height point center item2">
								전면
							</S.TableCell>
						)}

						<S.TableCell style={{ gridArea: 'item8' }} className={`min-height point center ${isMobile ? 'head' : ''}`}>
							컬러
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item9' }} className="min-height">
							110 만원
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item10' }} className="min-height center">
							90 만원
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item11' }} className="min-height">
							99 만원
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item12' }} className="min-height center">
							80 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item13' }} className="min-height center">
							80 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item14' }} className={`min-height point center ${isMobile ? 'head' : ''}`}>
							흑백
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item15' }} className="min-height">
							-
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item16' }} className="min-height center">
							70 만원
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item17' }} className="min-height">
							-
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item18' }} className="min-height center">
							60 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item19' }} className="min-height center">
							60 만원
						</S.TableCell>
					</S.Table>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>광고안 제출마감일</S.ContentTitleSub>
					<S.ContentDescription>광고안 제출 마감일은 학회 사무국(scsk1968@naver.com)으로 문의</S.ContentDescription>

					{/* <S.Table className="table2">
						<S.TableHeadCell className="item1">권호</S.TableHeadCell>
						<S.TableHeadCell>접수마감</S.TableHeadCell>
						<S.TableHeadCell>발간예정일</S.TableHeadCell>

						<S.TableCell className="min-height point item2">매년</S.TableCell>
						<S.TableCell className="min-height point">1호</S.TableCell>
						<S.TableCell className="min-height">01월 15일</S.TableCell>
						<S.TableCell className="min-height">03월 30일</S.TableCell>

						<S.TableCell className="min-height point">2호</S.TableCell>
						<S.TableCell className="min-height">04월 15일</S.TableCell>
						<S.TableCell className="min-height">06월 30일</S.TableCell>

						<S.TableCell className="min-height point">3호</S.TableCell>
						<S.TableCell className="min-height">07월 15일</S.TableCell>
						<S.TableCell className="min-height">09월 30일</S.TableCell>

						<S.TableCell className="min-height point">4호</S.TableCell>
						<S.TableCell className="min-height">10월 15일</S.TableCell>
						<S.TableCell className="min-height">12월 30일</S.TableCell>
					</S.Table> */}
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>문의처</S.ContentTitleSub>
					<S.ContentDescription>(사)대한화장품학회 사무국 (TEL.02-6713-1968)</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>제출처</S.ContentTitleSub>
					<S.ContentDescription>
						우편접수 05386 서울특별시 송파구 법원로 127, 316호(문정동, 대명벨리온)
						<br />
						메일접수 scsk1968@naver.com
						<br />
						TEL 02-6713-1968
						<br />
						FAX 02-6713-1969
					</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>제출서류</S.ContentTitleSub>
					<S.ContentDescription>게재를 희망하시는 분은 아래의 표를 작성하여 학회 팩스 또는 전자우편으로 보내 주시면 감사하겠습니다.</S.ContentDescription>
					<S.Table className="table3">
						<S.TableHeadCell className="center">업체명</S.TableHeadCell>
						<S.TableHeadCell className="center">담당자</S.TableHeadCell>
						<S.TableHeadCell className="center">광고회수</S.TableHeadCell>
						<S.TableHeadCell className="center">게재면</S.TableHeadCell>
						<S.TableHeadCell className="center">광고 게재시기</S.TableHeadCell>
						<S.TableHeadCell className="center">
							연락처
							<br />
							(전화/팩스/e-mail)
						</S.TableHeadCell>
						<S.TableHeadCell className="center">주소</S.TableHeadCell>

						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
					</S.Table>
				</S.ContentListLayout>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>프로시딩북 광고게재 안내</S.ContentTitle>
				<S.ContentListLayout>
					<S.ContentTitleSub>발행회수</S.ContentTitleSub>
					<S.ContentDescription>연 2 회</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>발행일</S.ContentTitleSub>
					<S.ContentDescription>춘, 추계학술발표대회 당일 (5월, 11월)</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>1회 광고료</S.ContentTitleSub>
					<S.Table className="table1 proceeding">
						<S.TableHeadCell className="center item1" style={{ gridArea: 'item1' }}>
							구분
						</S.TableHeadCell>
						{/* <S.TableHeadCell style={{ gridArea: 'item2' }}>뒷표지</S.TableHeadCell> */}
						<S.TableHeadCell className="center" style={{ gridArea: 'item3' }}>
							뒷 표지 안쪽
						</S.TableHeadCell>
						{/* <S.TableHeadCell style={{ gridArea: 'item4' }}>앞쪽 내지 1쪽</S.TableHeadCell> */}
						<S.TableHeadCell className="center" style={{ gridArea: 'item5' }}>
							앞쪽 내지 2쪽 이하
						</S.TableHeadCell>
						<S.TableHeadCell className="center" style={{ gridArea: 'item6' }}>
							뒤쪽 내지부분
						</S.TableHeadCell>

						{!isMobile && (
							<S.TableCell style={{ gridArea: 'item7' }} className="min-height point center item2">
								전면
							</S.TableCell>
						)}

						<S.TableCell style={{ gridArea: 'item8' }} className={`min-height point center ${isMobile ? 'head' : ''}`}>
							컬러
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item9' }} className="min-height">
							110 만원
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item10' }} className="min-height center">
							90 만원
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item11' }} className="min-height">
							99 만원
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item12' }} className="min-height center">
							80 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item13' }} className="min-height center">
							80 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item14' }} className={`min-height point center ${isMobile ? 'head' : ''}`}>
							흑백
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item15' }} className="min-height">
							-
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item16' }} className="min-height center">
							70 만원
						</S.TableCell>
						{/* <S.TableCell style={{ gridArea: 'item17' }} className="min-height">
							-
						</S.TableCell> */}
						<S.TableCell style={{ gridArea: 'item18' }} className="min-height center">
							60 만원
						</S.TableCell>
						<S.TableCell style={{ gridArea: 'item19' }} className="min-height center">
							60 만원
						</S.TableCell>
					</S.Table>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>광고안 제출마감일</S.ContentTitleSub>
					<S.ContentDescription>광고안 제출 마감일은 학회 사무국(scsk1968@naver.com)으로 문의</S.ContentDescription>
					{/* <S.Table className="table2">
						<S.TableHeadCell className="item1">권호</S.TableHeadCell>
						<S.TableHeadCell>접수마감</S.TableHeadCell>
						<S.TableHeadCell>발간예정일</S.TableHeadCell>

						<S.TableCell className="min-height point item2">매년</S.TableCell>
						<S.TableCell className="min-height point">1호</S.TableCell>
						<S.TableCell className="min-height">01월 15일</S.TableCell>
						<S.TableCell className="min-height">03월 30일</S.TableCell>

						<S.TableCell className="min-height point">2호</S.TableCell>
						<S.TableCell className="min-height">04월 15일</S.TableCell>
						<S.TableCell className="min-height">06월 30일</S.TableCell>

						<S.TableCell className="min-height point">3호</S.TableCell>
						<S.TableCell className="min-height">07월 15일</S.TableCell>
						<S.TableCell className="min-height">09월 30일</S.TableCell>

						<S.TableCell className="min-height point">4호</S.TableCell>
						<S.TableCell className="min-height">10월 15일</S.TableCell>
						<S.TableCell className="min-height">12월 30일</S.TableCell>
					</S.Table> */}
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>문의처</S.ContentTitleSub>
					<S.ContentDescription>(사)대한화장품학회 사무국 (TEL.02-6713-1968)</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout>
					<S.ContentTitleSub>제출처</S.ContentTitleSub>
					<S.ContentDescription>
						우편접수 05386 서울특별시 송파구 법원로 127, 316호(문정동, 대명벨리온)
						<br />
						메일접수 scsk1968@naver.com
						<br />
						TEL 02-6713-1968
						<br />
						FAX 02-6713-1969
					</S.ContentDescription>
				</S.ContentListLayout>
				<S.ContentListLayout className="flex-col">
					<S.ContentTitleSub>제출서류</S.ContentTitleSub>
					<S.ContentDescription>게재를 희망하시는 분은 아래의 표를 작성하여 학회 팩스 또는 전자우편으로 보내 주시면 감사하겠습니다.</S.ContentDescription>
					<S.Table className="table3">
						<S.TableHeadCell className="center">업체명</S.TableHeadCell>
						<S.TableHeadCell className="center">담당자</S.TableHeadCell>
						<S.TableHeadCell className="center">광고회수</S.TableHeadCell>
						<S.TableHeadCell className="center">게재면</S.TableHeadCell>
						<S.TableHeadCell className="center">광고 게재시기</S.TableHeadCell>
						<S.TableHeadCell className="center">
							연락처
							<br />
							(전화/팩스/e-mail)
						</S.TableHeadCell>
						<S.TableHeadCell className="center">주소</S.TableHeadCell>

						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
						<S.TableCell className="min-height" />
					</S.Table>
				</S.ContentListLayout>
			</S.ContentBox>
		</S.Container>
	);
};

export default PublicationAdvertisementGuide;
